<div class="fade modal modal-static pg-show-modal" id="modal-login-user" tabindex="-1" role="dialog" aria-hidden="true"
    data-backdrop="static">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Postular a anuncio</h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
                    title="Cerrar modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="container-gray-200 text-center">
                    <h5 class="font-size-16 heading-multi-styles">Postular a
                        <br>
                        <span
                            class="font-size-18 font-weight-bold text-primary">{{jobTitle ? jobTitle : jobPosition}}</span>&nbsp;<ng-container *ngIf="jobGradeFrom">, <span class="font-size-18 font-weight-bold text-primary">{{jobGradeFrom}}<ng-container *ngIf="jobGradeFrom !== jobGradeTo"> a {{jobGradeTo}}</ng-container></span>
                            </ng-container>

                        
                    </h5>
                    <div
                        class="alert alert-warning mgn-bottom-40 align-items-center d-flex font-size-13 justify-content-center text-dark text-left">
                        <div>
                            <i class="mgn-rigth-8 pj-ico pj-ico-170 pj-ico-info text-primary"></i>
                        </div>
                        <div>
                            Para postular a este anuncio debes iniciar sesión.
                            <br>
                            Si aún no tienes una cuenta, regístrate para postular.
                        </div>
                    </div>
                    <div class="space-items-15" data-pg-collapsed>
                        <button class="btn btn-primary" (click)="onClickLoginButton($event)"
                            data-dismiss="modal" type="button">Iniciar sesión</button>
                        <button class="btn btn-outline-primary" data-dismiss="modal"
                            (click)="onClickRegisterButton($event)">Registrarme</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>